import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=5a90ec03&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/fcs/fcs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a90ec03')) {
      api.createRecord('5a90ec03', component.options)
    } else {
      api.reload('5a90ec03', component.options)
    }
    module.hot.accept("./Home.vue?vue&type=template&id=5a90ec03&", function () {
      api.rerender('5a90ec03', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Home.vue"
export default component.exports